module.exports = "<div id=\"wrapper\">\n  <div class=\"row row-content no-gutters\">\n    <app-header id=\"header\" class=\"col-12 align-self-start\"></app-header>\n    <router-outlet></router-outlet>\n  </div>\n</div>\n\n<!--<app-footer id=\"footer\" class=\"col-12 align-self-end main-boxshadow\"></app-footer>-->\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main